'use client'
import { useGetCompanyProductsQuery } from '@/app/globalRedux/api/filter/companySearchSlice'
import {
  addOrRemoveCompanyLocation,
  addOrRemoveCompanyLocationContinents,
  addOrRemoveProductLocation,
  addOrRemoveProductLocationContinents,
  setCompanyLocation,
  setProductLocation,
} from '@/app/globalRedux/filter/commonFilter'
import {
  addOrRemoveCompanySelectedActivity,
  setSelectAllCompanyBuyers,
  setSelectAllCompanySuppliers,
} from '@/app/globalRedux/filter/companyFilter'
import {
  Product,
  addAllCultivationType,
  addOrRemoveFruitVegetableActivity,
  addOrRemoveFvProductFilterSelectedProduct,
  productFvStaticBuyer,
  productFvStaticSupplier,
  removeAllCultivationType,
  setAddOrRemoveAvailability,
  setCultivationType,
  setFvProductSelectAllProducts,
  setSelectAllProductBuyers,
  setSelectAllProductSuppliers,
} from '@/app/globalRedux/filter/productFilter'
import { RootState } from '@/app/globalRedux/store'
import { useTranslation } from '@/app/i18n/client'
import { months } from '@/app/utils/numberToMonth'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import SearchIcon from '@mui/icons-material/Search'
import { InputAdornment, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CompanyLocationFilter from '../CommonFilters/CompanyLocationFilter'

const ProductFruitVegtableFilter = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const productFilter = useSelector((state: RootState) => state.productFilter)
  const { data: productData = [] } = useGetCompanyProductsQuery<{
    data: Product[]
    isLoading: boolean
    isError: boolean
  }>(productFilter.sector)
  const [productOriginCountrySearchText, setProductOriginCountrySearchText] =
    useState<string>('')
  const { productFvListedSupplier, productFvListedBuyer } = useSelector(
    (state: RootState) => state.productFilterList
  )
  const commonFilter = useSelector((state: RootState) => state.commonFilter)
  const [allbuyerSelected, setAllbuyerSelected] = useState<boolean>(false)
  const [allsupplierSelected, setAllsupplierSelected] = useState<boolean>(false)
  const [companyLocation, setCompanyLocationText] = useState<string>('')
  const [productText, setProductText] = useState<string>('')

  useEffect(() => {
    const activitySet = new Set(productFilter.productFruitVegetableActivity)
    setAllbuyerSelected(
      productFvStaticBuyer.every((buyer) => activitySet.has(buyer))
    )
    setAllsupplierSelected(
      productFvStaticSupplier.every((supplier) => activitySet.has(supplier))
    )
  }, [productFilter.productFruitVegetableActivity])

  useEffect(() => {
    setProductText('')
    setCompanyLocationText('')
  }, [productFilter?.clearFilter])

  return (
    <div>
      {/* Cultivation Type */}
      {/* Activity */}
      <div className="shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-neutral-50 border border-solid border-[#ebebeb] mt-[20px] rounded-[4px] mobile:mt-[10px]">
        <div>
          <Accordion type="single" collapsible defaultValue="item-2">
            <AccordionItem value="item-2">
              <AccordionTrigger className="text-[18px] font-semibold text-[#222]">
                {t('Activities')}
              </AccordionTrigger>
              <AccordionContent className="!p-0 ">
                {/* {Suppliers} */}
                <Accordion
                  type="single"
                  collapsible
                  className="!p-0 "
                  defaultValue="supplier"
                >
                  <AccordionItem value="supplier">
                    <AccordionTrigger className="text-[18px] font-semibold text-[#222] bg-[#eaeaea] mb-[10px]">
                      <span
                        className=" flex flex-row   items-center w-[100%] gap-[10px]"
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                        }}
                      >
                        <Checkbox
                          className=" bg-[white]"
                          checked={allsupplierSelected}
                          onClick={() => {
                            dispatch(setSelectAllProductSuppliers())
                            dispatch(setSelectAllCompanySuppliers())
                          }}
                        />
                        <p>{t('Suppliers')}</p>
                      </span>
                    </AccordionTrigger>
                    <AccordionContent>
                      <div className="flex flex-col  gap-[8px]">
                        {productFvListedSupplier?.map(
                          (supplier: {
                            value: string
                            activityCount: number
                          }) => (
                            <div
                              className=" flex flex-row items-center gap-2 "
                              key={supplier?.value}
                            >
                              <Checkbox
                                checked={productFilter.productFruitVegetableActivity.includes(
                                  supplier?.value
                                )}
                                id={supplier?.value}
                                className="border-2 border-input"
                                onClick={() => {
                                  dispatch(
                                    addOrRemoveFruitVegetableActivity(
                                      supplier?.value
                                    )
                                  )
                                  dispatch(
                                    addOrRemoveCompanySelectedActivity(
                                      supplier?.value
                                    )
                                  )
                                }}
                              />
                              <Label
                                htmlFor={supplier?.value}
                                className="cursor-pointer  text-sm  not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f] flex flex-row"
                              >
                                {t(supplier?.value)}
                                <span className=" ml-1 gap-[1px] flex flex-row">
                                  ({`${supplier?.activityCount}`})
                                </span>
                              </Label>
                            </div>
                          )
                        )}
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>

                {/* {Buyers} */}

                <Accordion
                  type="single"
                  collapsible
                  className="!p-0 "
                  defaultValue="buyer"
                >
                  <AccordionItem value="buyer">
                    <AccordionTrigger className="text-[18px] font-semibold text-[#222] bg-[#eaeaea] mb-[10px] mt-[10px]">
                      <span
                        className=" flex flex-row   items-center w-[100%] gap-[10px]"
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                        }}
                      >
                        <Checkbox
                          className=" bg-[white]"
                          checked={allbuyerSelected}
                          onClick={() => {
                            dispatch(setSelectAllCompanyBuyers())
                            dispatch(setSelectAllProductBuyers())
                          }}
                        />
                        <p>{t('Buyers')}</p>
                      </span>
                    </AccordionTrigger>
                    <AccordionContent>
                      <div className="flex flex-col  gap-[8px]  ">
                        {productFvListedBuyer?.map(
                          (buyer: { value: string; activityCount: number }) => (
                            <div
                              className=" flex flex-row items-center gap-2 "
                              key={buyer?.value}
                            >
                              <Checkbox
                                checked={productFilter.productFruitVegetableActivity.includes(
                                  buyer?.value
                                )}
                                id={buyer?.value}
                                className="border-2 border-input"
                                onClick={() => {
                                  dispatch(
                                    addOrRemoveFruitVegetableActivity(
                                      buyer?.value
                                    )
                                  )
                                  dispatch(
                                    addOrRemoveCompanySelectedActivity(
                                      buyer?.value
                                    )
                                  )
                                }}
                              />
                              <Label
                                htmlFor={buyer?.value}
                                className=" cursor-pointer text-sm  not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f] flex flex-row"
                              >
                                {t(buyer?.value)}
                                <span className=" ml-1 gap-[1px] flex flex-row">
                                  ({`${buyer?.activityCount}`})
                                </span>
                              </Label>
                            </div>
                          )
                        )}
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
      <div className="shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-neutral-50 border border-solid border-[#ebebeb] mt-[20px] rounded-[4px] mobile:mt-[10px]">
        <div>
          <Accordion type="single" collapsible defaultValue="CultivationType">
            <AccordionItem value="CultivationType">
              <AccordionTrigger className="text-[18px] font-semibold text-[#222] pb-[0px]">
                {t('Cultivation Type')}
              </AccordionTrigger>
              <AccordionContent>
                <div className="flex flex-col  gap-[8px]  max-h-[200px] overflow-y-scroll ">
                  <div className=" flex flex-row items-center gap-2 ">
                    <Checkbox
                      checked={
                        productFilter.cultivationType.includes(
                          'Conventional'
                        ) && productFilter.cultivationType.includes('Organic')
                      }
                      id={'All'}
                      className=" cursor-pointer border-2 border-input"
                      onClick={() => {
                        if (productFilter.cultivationType.length !== 2) {
                          dispatch(addAllCultivationType())
                        } else {
                          dispatch(removeAllCultivationType())
                        }
                      }}
                    />
                    <Label
                      htmlFor="All"
                      className=" cursor-pointer  text-sm  not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]"
                    >
                      {t('All')}
                    </Label>
                  </div>
                  <div className=" flex flex-row items-center gap-2 ">
                    <Checkbox
                      checked={productFilter.cultivationType.includes(
                        'Conventional'
                      )}
                      id="Conventional"
                      className="border-2 border-input"
                      onClick={() => {
                        dispatch(setCultivationType('Conventional'))
                      }}
                    />

                    <Label
                      htmlFor="Conventional"
                      className="cursor-pointer  text-sm  not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]"
                    >
                      {t('Conventional')}
                    </Label>
                  </div>
                  <div className=" flex flex-row items-center gap-2 ">
                    <Checkbox
                      checked={productFilter.cultivationType.includes(
                        'Organic'
                      )}
                      id="Organic"
                      className="border-2 border-input"
                      onClick={() => {
                        dispatch(setCultivationType('Organic'))
                      }}
                    />

                    <Label
                      htmlFor="Organic"
                      className=" cursor-pointer  text-sm  not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]"
                    >
                      {t('Organic')}
                    </Label>
                  </div>
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
      {/* Products */}
      <div className="shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-neutral-50 border border-solid border-[#ebebeb] mt-[20px] rounded-[4px] mobile:mt-[10px]">
        <Accordion type="single" collapsible defaultValue="products">
          <AccordionItem value="products">
            <AccordionTrigger className="text-[18px] font-semibold text-[#222] pb-[0px]">
              {t('Product')}
            </AccordionTrigger>
            <AccordionContent>
              <TextField
                className=" w-[100%]"
                value={productText}
                onChange={(event) => {
                  setProductText(event?.target?.value)
                }}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" className="ml-[10px] ">
                      <SearchIcon className="!w-[17.6px] !h-[17.6px]" />
                    </InputAdornment>
                  ),
                }}
                placeholder={t('Search Products')}
              />
              <div className="flex flex-col  gap-[8px]  max-h-[200px] overflow-y-scroll !mt-[10px] ">
                <div className="flex items-center gap-2">
                  <Checkbox
                    checked={
                      productFilter?.productFilterFvSelectedProducts?.length ===
                      productData?.length
                    }
                    id="select-all-products"
                    className="border-2 border-input"
                    onClick={() => {
                      dispatch(setFvProductSelectAllProducts(productData ?? []))
                    }}
                  />
                  <Label
                    htmlFor="select-all-products"
                    className="text-sm not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]"
                  >
                    {t('Select All Products')}
                  </Label>
                </div>
                {productData
                  ?.filter((item) =>
                    item?.name
                      ?.toLowerCase()
                      .includes(productText?.toLowerCase())
                  )

                  ?.map((product: Product) => (
                    <div
                      className=" flex flex-row items-center gap-2 "
                      key={product?.name + 'list'}
                    >
                      <Checkbox
                        checked={productFilter.productFilterFvSelectedProducts.some(
                          (p) => p.id === product?.id
                        )}
                        id={product?.name}
                        className="border-2 border-input"
                        onClick={() => {
                          dispatch(
                            addOrRemoveFvProductFilterSelectedProduct(product)
                          )
                        }}
                      />
                      <Label
                        htmlFor={product?.name}
                        className="  cursor-pointer text-sm  not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]"
                      >
                        {product?.name}
                      </Label>
                    </div>
                  ))}
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
      {/* Product Origin */}
      <CompanyLocationFilter
        searchTitle={'Product Origin'}
        locationText={productOriginCountrySearchText}
        setLocationText={setProductOriginCountrySearchText}
        continentSelectedList={commonFilter?.productLocationContients}
        countrySelectedList={commonFilter?.productLocation}
        setWholeLocation={setProductLocation}
        addOrRemoveSelectedCountryList={addOrRemoveProductLocation}
        addOrRemoveSelectedContinentList={addOrRemoveProductLocationContinents}
      />
      {/* Availability */}
      <div className="shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-neutral-50 border border-solid border-[#ebebeb] mt-[20px] rounded-[4px] mobile:mt-[10px]">
        <Accordion type="single" collapsible defaultValue="availability">
          <AccordionItem value="availability">
            <AccordionTrigger className="text-[18px] font-semibold text-[#222] pb-[0px]">
              {t('Availability')}
            </AccordionTrigger>
            <AccordionContent>
              <div className="flex flex-col ">
                <div className="flex flex-col  gap-[8px]  mt-0  max-h-[200px] overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
                  <RadioGroup
                    onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                      const value = (e.target as HTMLInputElement).value
                      if (value) {
                        dispatch(setAddOrRemoveAvailability(value))
                      }
                    }}
                  >
                    {months.map((month: string) => (
                      <div
                        className=" flex flex-row items-center gap-2  checked-color"
                        key={month}
                      >
                        <Label
                          key={month}
                          className="flex   gap-2  text-sm  not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]"
                        >
                          <RadioGroupItem
                            value={month}
                            className=" !text-[#df7d2f]"
                            checked={
                              productFilter?.productFVAvailability == month
                            }
                          />
                          {t(month)}
                        </Label>
                      </div>
                    ))}
                  </RadioGroup>
                </div>
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
      {/* Company Location */}
      <CompanyLocationFilter
        searchTitle={'Company Location'}
        locationText={companyLocation}
        setLocationText={setCompanyLocationText}
        continentSelectedList={commonFilter?.companyLocationContinents}
        countrySelectedList={commonFilter?.companyLocation}
        setWholeLocation={setCompanyLocation}
        addOrRemoveSelectedCountryList={addOrRemoveCompanyLocation}
        addOrRemoveSelectedContinentList={addOrRemoveCompanyLocationContinents}
      />
    </div>
  )
}

export default ProductFruitVegtableFilter
